import { render } from "./InfoRowDetailsStatusReport.vue?vue&type=template&id=56a5cdd5&scoped=true"
import script from "./InfoRowDetailsStatusReport.vue?vue&type=script&lang=js"
export * from "./InfoRowDetailsStatusReport.vue?vue&type=script&lang=js"

import "./InfoRowDetailsStatusReport.vue?vue&type=style&index=0&id=56a5cdd5&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56a5cdd5"]])

export default __exports__